import { Step } from 'components/SteppedDialog/Step';
import { SteppedDialog } from 'components/SteppedDialog/SteppedDialog';
import { CloudLicensingOverviewDiagram } from 'pages/SnapshotManagement/CloudLicensingGuide/CloudLicensingOverviewDiagram';
import { CloudLicensingSeparationDiagram } from 'pages/SnapshotManagement/CloudLicensingGuide/CloudLicensingSeparationDiagram';
import { CloudLicensingTieringDiagram } from 'pages/SnapshotManagement/CloudLicensingGuide/CloudLicensingTieringDiagram';
import type { FC } from 'react';
import { useNavigatePushPath } from 'utils/history/useNavigatePushPath';

export type CloudLicensingGuideProps = {
  onClose: () => void;
};

export const CloudLicensingGuide: FC<CloudLicensingGuideProps> = ({
  onClose,
}) => {
  const navigatePushPath = useNavigatePushPath();

  const handleGoToOverview = () => {
    onClose();
    navigatePushPath('/settings/administration/license-consumption/overview');
  };

  return (
    <SteppedDialog onClose={onClose} onComplete={handleGoToOverview}>
      <Step title='Cloud now has its own licences'>
        <div className='flex flex-col gap-sm'>
          <CloudLicensingSeparationDiagram />
          <p className='text-base text-default'>
            On-prem and cloud are now licensed separately. Same product — two
            parallel pools, each with its own capacity and consumption.
          </p>
        </div>
      </Step>

      <Step title='CCU cost comes in three tiers'>
        <div className='flex flex-col gap-sm'>
          <CloudLicensingTieringDiagram />
          <p className='text-base text-default'>
            Cloud licensing uses Cloud Consumption Units (CCUs). Each cloud
            object falls into Tier A, Tier B, or Tier C — each setting its CCU
            cost. Tier C objects don't contribute to the CCU consumption.
          </p>
        </div>
      </Step>

      <Step
        title='New Licence overview screen'
        nextLabel='Go to overview'
        showClose
      >
        <div className='flex flex-col gap-sm'>
          <CloudLicensingOverviewDiagram />
          <p className='text-base text-default'>
            See consumption across on-prem and cloud or check remaining headroom
            — all from one page under{' '}
            <span className='font-semibold'>
              Settings → Administration → Licence overview
            </span>
            .
          </p>
        </div>
      </Step>
    </SteppedDialog>
  );
};
